"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flex = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../constants");
var _FlexMixin = require("../../mixins/components/FlexMixin");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
/**
 * A component implementation of standard CSS Flexbox.
 * No CSS will be added/browser defaults will be used unless you set a prop.
 * All props are camel-cased CSS attributes. By default,
 * each `Flex` component uses a `div` -- if needed, you can use the styled-components
 * [`as`](https://www.styled-components.com/docs/api#as-polymorphic-prop) prop to change
 * the element type.
 *
 * **All `Flex` props support inline media query objects.**
 * @related ['Grid']
 * @since 5.0.0
 */

var Flex = /*#__PURE__*/(0, _styledComponents.default)('div').withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['display', 'order'])
}).withConfig({
  displayName: "Flex",
  componentId: "c11n-8-107-0__sc-n94bjd-0"
})(["", ""], _FlexMixin.FlexMixin);
exports.Flex = Flex;
Flex.displayName = 'Flex';
Flex.propTypes = {
  /** (flex containers) */
  display: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['flex', 'inline-flex', 'none'])),
  /** (flex containers) */
  flexDirection: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse'])),
  /** (flex containers) */
  flexFlow: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** (flex containers) */
  flexWrap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse'])),
  /** (flex containers) */
  justifyContent: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'])),
  /** (flex containers) */
  alignItems: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch'])),
  /** (flex containers) */
  alignContent: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'stretch'])),
  /** (flex items) */
  flex: _customPropTypes.default.inlineMediaQuery(_propTypes.default.string),
  /** (flex items) */
  order: _customPropTypes.default.inlineMediaQuery(_propTypes.default.number),
  /** (flex items) */
  flexGrow: _customPropTypes.default.inlineMediaQuery(_propTypes.default.number),
  /** (flex items) */
  flexShrink: _customPropTypes.default.inlineMediaQuery(_propTypes.default.number),
  /** (flex items) */
  flexBasis: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  /** (flex items) */
  alignSelf: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['auto', 'flex-start', 'flex-end', 'center', 'baseline', 'stretch'])),
  /** (flex gap) */
  gap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOfType([_propTypes.default.oneOf(Object.values(_constants.T_SHIRT_SIZES)), _propTypes.default.number])),
  /**
   * @deprecated Use inline media query objects
   */
  mediaQuery: _customPropTypes.default.mediaQuery
};

/** @component */